exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fieldset.alignLeft label {\r\n    justify-content: initial;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .row.vdivide [class*='column']:not(:last-child):after {\r\n        background: #ddd;\r\n        width: 1px;\r\n        content: \"\";\r\n        display: block;\r\n        position: absolute;\r\n        top: 0;\r\n        bottom: 0;\r\n        right: 0;\r\n        height: auto;\r\n        margin-top: 0;\r\n    }\r\n}\r\n\r\n.btn-block{\r\n    width: auto;\r\n}\r\n", ""]);

// exports
